class FundationNavModule {
    constructor() {
        this.initialize();
    }

    initialize() {
        this.bindUI();
        this.initNav();
    }

    bindUI() {
        this.ui = {};

        this.ui.$nav = document.querySelector(".js-fundation-nav");
        this.ui.$list = this.ui.$nav.querySelector(".fundation-nav-list");
        this.ui.$line = this.ui.$nav.querySelector(".line");
    }

    updateActiveItem(activeItem) {
        this.ui.$list.querySelectorAll("[data-anchor]").forEach((item) => {
            item.classList.remove("active");
        });

        // activeItem.scrollIntoView();
        activeItem.classList.add("active");
    }

    initNav() {
        const titles = document.querySelectorAll("[data-nav]");
        let html = "";

        titles.forEach((title, index) => {
            html += `
                <li class="subnav-item">
                    <button${
                        index === 0 ? ' class="active"' : ""
                    } data-anchor="${title.id}">${title.dataset.nav}</button$>
                </li>
            `;
        });

        this.ui.$list.innerHTML = html;

        this.ui.$list
            .querySelectorAll(".subnav-item button")
            .forEach((button) => {
                button.addEventListener("click", () => {
                    document
                        .querySelector(`#${button.dataset.anchor}`)
                        .scrollIntoView();
                });
            });

        titles.forEach((title) => {
            const self = this;
            const observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            self.updateActiveItem(
                                document.querySelector(
                                    `[data-anchor="${entry.target.id}"]`
                                )
                            );
                        }
                    });
                },
                {
                    // root: document.querySelector('#scrollArea'),
                    // rootMargin: '0px',
                    threshold: 1.0,
                }
            );

            observer.observe(title);
        });
    }
}

export default FundationNavModule;
